<template>
  <section>
    <div class="row m-4">
      <div class="col-md-8" :class="[{'toogle-el': toogleRealtime}]">
        <TbFilaURA @open-modal-transf="handleOpenModalTransf"/>
        <ModalTransferencia ref="modalTransferencia" :valueClient="dadoClient"></ModalTransferencia>
        <TbFilaAtendimento @open-modal-transf="handleOpenModalTransf"/>
        <TbFilaAndamento @open-modal-transf="handleOpenModalTransf"/>
      </div>

      <div class="col-md-4 p-0" :class="!toogleRealtime ? 'container-align' : 'toogle-el'">
        <TbFilaDetail class="m-2"/>
        <TbFilaAtendimentoOperador class="m-2"/>
        <GraficoRespondids class="m-2"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8" :class="!toogleRealtime ? 'container-align' : 'toogle-el'">
        <TbUsers ref="tbUsers"/>
      </div>
      <div class="col-md-4" :class="[{'toogle-el': toogleRealtime}]">
        <GraficoOcupacaoAgent/>
      </div>
    </div>
  </section>
</template>

<script>
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import RealtimePhone from './RealtimePhone.vue';
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAtendimentoOperador from "./components/TbFilaAtendimentoOperador";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";
import ModalTransferencia from '../../components/newScreen/mensagem/ModalTransferencia.vue';

const socket = require('./../../modules/realtime/service/service');

export default {
  name: "RealtimeApp",
  data(){
    return{
      toogleRealtime: false,
      intervalId: null,
      cl: 'toogle',
      _onConnect: null,
      _unsubStore: null,
      hasJoinedRealtime: false,  
      dadoClient: {}
    }
  },
  mounted() {
    const getOperator = () =>
      this.$store?.getters?.getUser?.extension_line ??
      window?.ADVANCE?.operator ??
      null;

    const buildPayload = () => ({
      operator: getOperator(),
      href: window.location.href
    });

    if (socket?.connection?.connected && !this.hasJoinedRealtime) {
      try {
        socket.connection.emit('realtime:join', buildPayload());
        this.hasJoinedRealtime = true;
      } catch (e) {}
    }

    this._onConnect = () => {
      if (!this.hasJoinedRealtime) {
        try {
          socket.connection.emit('realtime:join', buildPayload());
          this.hasJoinedRealtime = true;
        } catch (e) {}
      }
    };
    if (socket?.connection?.once) {
      socket.connection.once('connect', this._onConnect);
    } else if (socket?.connection?.on) {
      socket.connection.on('connect', this._onConnect);
    }

    this._unsubStore = this.$store?.subscribe?.((mutation, state) => {
      const op = getOperator();
      if (this.hasJoinedRealtime && op) {
        try {
          socket.connection.emit('realtime:identify', { operator: op, href: window.location.href });
        } catch (e) {}
        if (this._unsubStore) { this._unsubStore(); this._unsubStore = null; }
      }
    });
  },
  beforeDestroy() {
    try { socket.connection.emit('realtime:leave'); } catch (e) {}
    this.hasJoinedRealtime = false;

    const off = socket.connection?.off ? 'off' : 'removeListener';
    if (this._onConnect && socket?.connection?.[off]) {
      socket.connection[off]('connect', this._onConnect);
    }
    this._onConnect = null;

    if (this._unsubStore) { this._unsubStore(); this._unsubStore = null; }

    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods:{
    handleOpenModalTransf(dado) {
      this.dadoClient = dado;
      this.$nextTick(() => {
        this.$refs.modalTransferencia.openModal();
      });
    },
  },
  components: {
    TbFilaAtendimento, TbFilaURA, TbFilaAndamento, TbFilaDetail,
    GraficoOcupacaoAgent, GraficoRespondids, TbUsers, RealtimePhone,
    ModalTransferencia, TbFilaAtendimentoOperador
  },
}
</script>

<style scoped>
.toogle-el{ display:none; }
.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
